var Currencies = /* @__PURE__ */ ((Currencies2) => {
  Currencies2["EUR"] = "EUR";
  Currencies2["GBP"] = "GBP";
  Currencies2["USD"] = "USD";
  Currencies2["SEK"] = "SEK";
  Currencies2["DKK"] = "DKK";
  Currencies2["NOK"] = "NOK";
  Currencies2["CHF"] = "CHF";
  return Currencies2;
})(Currencies || {});
const CURRENCIES = Object.keys(Currencies);
const DEFAULT_CURRENCY = "EUR";
const DEFAULT_FORMAT = "--";
const calculateFractionDecimals = (value, isCentAmount, fixedDecimals) => {
  if (fixedDecimals) {
    return 2;
  }
  const remainder = value % (isCentAmount ? 100 : 1);
  return remainder === 0 ? 0 : 2;
};
const formatPrice = ({
  locale,
  value,
  currency,
  isCentAmount,
  fixedDecimals
}) => {
  if (value === void 0 || isNaN(value)) {
    return DEFAULT_FORMAT;
  }
  const priceCurrency = Currencies[currency || ""] ?? DEFAULT_CURRENCY;
  const number = isCentAmount ? value / 100 : value;
  const fractionDecimals = calculateFractionDecimals(value, isCentAmount, fixedDecimals);
  const price = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: priceCurrency,
    minimumFractionDigits: fractionDecimals,
    maximumFractionDigits: fractionDecimals
  }).format(number);
  return price;
};
export {
  CURRENCIES,
  formatPrice
};
//# sourceMappingURL=format-price.js.map
